import { Modal } from 'antd';
import styled from 'styled-components';
import { colors, sizes } from 'theme';

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        width: 100%;
        max-width: 840px;
        border-radius: ${sizes.radiusMd}px;
        overflow: hidden;
    }

    .ant-modal-footer {
        padding: 0;
    }

    .ant-modal-title {
        font-weight: 600;
        color: var(--brand-9);
        font-size: 20px;
        line-height: 28px;
    }
`;

export const StyledModalFooter = styled.footer`
    padding: 12px 24px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
`;

export const StyledIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    width: 64px;
    height: 64px;
    font-size: 120px;
    color: var(--brand-6);
    background-color: var(--brand-1);
`;

export const NewStyledModal = styled(Modal)`
    .ant-modal-content {
        width: 100%;
        border-radius: ${sizes.radiusMd}px;
        overflow: hidden;
        font-size: 14px;
        color: black;
    }

    .anticon {
        border-radius: 50%;
        background: ${colors.brand1};
        display: flex;
        justify-content: center;
        border: 12px solid ${colors.brand1};
        border-bottom: 6px solid ${colors.brand1};
        margin-bottom: 16px;
        margin-top: 8px;
    }

    .anticon svg {
        width: 48px !important;
        height: 48px !important;
        margin-bottom: 8px;
        color: ${colors.brand6};
    }

    .ant-modal-body {
        padding: 0;
        flex-direction: column;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
    }

    .ant-modal-header {
        padding-left: 10%;
    }

    .ant-modal-footer {
        padding-right: 10%;
    }

    .ant-modal-close-x .anticon {
        width: 16px !important;
        height: 16px !important;
    }

    .ant-modal-close-x .anticon svg {
        color: ${colors.grey7};
    }

    .ant-modal-title {
        color: ${colors.brand9};
        font-weight: 500;
        font-size: 20px;
    }
`;
